// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15-gI","clinicsSelect":"styles_clinicsSelect__3eT4m"};